import { zoneChannels } from '@/mocks/collections';
import SectionHead from './Section';

export default function ZonesSection() {
  return (
    <section id="zone" className="bg-paper-50 py-10 md:py-14 scroll-mt-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6 lg:px-8">
        <SectionHead
          kicker="吃瓜专区 · CHANNELS"
          title="按题材各就各位"
          desc="不同的瓜进不同的区，谁都能在这里找到同好。专区持续沉淀精华帖，新老吃瓜人都能快速定位自己的主场。"
          link="#zone"
        />

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {zoneChannels.map((z) => (
            <a
              key={z.id}
              href="#zone"
              className="group cursor-pointer overflow-hidden rounded-xl border border-paper-200 bg-paper-100 transition-colors hover:border-flame-500"
            >
              <div className="relative h-40 overflow-hidden">
                <img
                  src={z.banner}
                  alt={z.name}
                  title={`${z.name}专区 明星黑料讨论合集`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink-950/85 via-ink-950/20 to-transparent" />
                <span className="absolute left-3 top-3 rounded-full bg-ink-950/70 px-2.5 py-1 text-xs font-bold text-gold-300 backdrop-blur">
                  {z.count}
                </span>
                <div className="absolute bottom-3 left-4 right-4">
                  <h3 className="font-display text-xl font-black text-paper-50">{z.name}</h3>
                  <p className="mt-0.5 truncate text-xs font-semibold text-gold-200">本期热推：{z.lead}</p>
                </div>
              </div>
              <div className="flex items-center justify-between gap-3 p-4">
                <p className="text-sm leading-5 text-ink-600">{z.desc}</p>
                <span className="flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-bold text-flame-600 group-hover:text-flame-700">
                  进区
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                </span>
              </div>
            </a>
          ))}

          {/* 社区贡献 CTA 卡 */}
          <div className="flex flex-col justify-between overflow-hidden rounded-xl bg-gradient-to-br from-flame-600 to-flame-800 p-5 text-paper-50">
            <div>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-ink-950/30 px-3 py-1 text-xs font-black">
                <i className="ri-vip-crown-2-line text-gold-300" />
                共建专区
              </span>
              <h3 className="mt-4 font-display text-2xl font-black leading-snug">
                手里有料？
                <br />
                开个你的主战场
              </h3>
              <p className="mt-3 text-sm leading-6 text-paper-100/90">
                提交线索、整理时间线或发起话题，精华内容会被收录进专区与实锤合集。吃瓜不只是围观，也可以是共同见证。
              </p>
            </div>
            <div className="mt-5 flex flex-wrap items-center gap-2">
              {['认领话题', '投稿实锤', '整理时间线'].map((t) => (
                <span key={t} className="cursor-pointer whitespace-nowrap rounded-full border border-paper-50/40 px-3 py-1.5 text-xs font-bold transition-colors hover:bg-paper-50 hover:text-flame-700">
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}